<mat-form-field>
  <mat-label>{{ control.label }}</mat-label>
  <mat-select [formControl]="control.formControls[0].formControl">
    @for (option of selectOptions; track option) {
    <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
  <mat-error class="warning">
    @if(control.customOptions?.isRequired) {
    Design Package is Required
    }
  </mat-error>
</mat-form-field>